import { render } from "./menuReminders.vue?vue&type=template&id=50345ef0"
import script from "./menuReminders.vue?vue&type=script&lang=js"
export * from "./menuReminders.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__